<section id="services" class="services section py-5">
  <div class="container" data-aos="fade-up" data-aos-delay="100">

    <div class="row gy-5" *ngIf="servicios.length > 0">

      <div  *ngFor="let item of servicios" class="col-xl-4 col-sm-6" data-aos="zoom-in" data-aos-delay="200" >
        <div class="service-item">
          <a routerLink="/servicios/{{item.url}}" class="">

          <div class="img">
            <img src="assets/img/{{item.imagenUrl}}" class="img-fluid" alt="{{ item.name }}">
          </div>
          <div class="details position-relative">
            <div class="icon">
              <img ngSrc="assets/img/{{item.icono}}" alt="" height="50" width="50">
            </div>
              <h3>{{ item.name }}</h3>
          </div>

          </a>

        </div>
      </div>
    </div>


  </div>

</section><!-- /Services Section -->
